import  { useEffect, useState } from "react";
import axios from "axios";

import HeaderLogo from "../components/common/HeaderLogo";
import Footer from "../components/common/Footer";
import Loader from "../components/common/Loader";

function TermAndCondition() {
  const [htmlContent, setHtmlContent] = useState("");


  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Fetch HTML content from your API
    const fetchTerms = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/v1/support/cms`
        ); // replace with your actual endpoint
        setHtmlContent(response.data.data.termsAndConditions); // assuming API returns { html: "..." }
      } catch (err) {
        console.error(err);
        setError("Failed to load Terms & Conditions.");
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
    // eslint-disable-next-line
  }, []);

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  if (error) return <div>{error}</div>;

  return (
    <div>
      <HeaderLogo />
      <div className="mx-6 md:mx-12  mb-[30px]">
        {/* Render API HTML safely */}
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
      <Footer />
    </div>
  );
}

export default TermAndCondition;
